import { render, staticRenderFns } from "./MentorGroupsView.vue?vue&type=template&id=d36a4dba&scoped=true&"
import script from "./MentorGroupsView.vue?vue&type=script&lang=ts&"
export * from "./MentorGroupsView.vue?vue&type=script&lang=ts&"
import style0 from "./MentorGroupsView.vue?vue&type=style&index=0&id=d36a4dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36a4dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VRow,VSelect})
